import { CLEAR_PAGE } from "./types";
import { getMainSiteUrl } from "@/utils/helpers";

export const clearPage = (slug) => {
  return {
    type: CLEAR_PAGE,
    payload: slug,
  };
};

export const refreshCache = (tag = 'all') => {
  return fetch(getMainSiteUrl(`/revalidate?tag=${tag}`));
}